import * as reducers from '../reducers/index';

function loadState() {
  try {
    const serialisedState = window.localStorage && window.localStorage.getItem('SFP_STORAGE');
    if (serialisedState) {
      const storedState = JSON.parse(serialisedState);
      const reducerState = {};
      Object.entries(storedState).forEach(([reducerName, values]) => {
        reducerState[reducerName] = {
          // run the reducer to produce the initial state
          ...(reducers[reducerName] || (() => {}))(undefined, {}),
          // now the new values
          ...values
        };
      });

      return {
        ...reducerState
      };
    }
  } catch (error) {
    // No need to handle error, simply use the default initial state
  }

  return {};
}

export default loadState;
